// // NEW WITH STORING CHECKED IN A VARIABLE- 
// import React, { useMemo, useRef, useCallback, useState, useEffect } from "react";
// import { AgGridReact } from "ag-grid-react";
// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-material.css";
// import api from "../../utils/api";
// import Spinner from "../../common/Spinner/Spinner";
// import Select from "react-select";
// import { Button } from "../../common/Button/Button";
// import { toast } from 'react-toastify'

// const PendingPartnerMasterGrid = ({ tableData, setPendingApprovalPartnerList, selectedPendingPartnerName, setSelectedPendingPartnerName, loading, isRelatedPartnerLoading, parentFieldOptions, parentFieldValue, setParentFieldValue, selectedPartnerForUser, setSelectedPartnerForUser, approvePartnerName, deletePartnerName, getRelatedPartnerName = { getRelatedPartnerName }, setGetRelatedPartnerName, setPartnerNameValueForEditPartner, setParentFieldValueForEditPartner, setSelectedRowEdit, handleEntryPointEditByChecker, hasCheckerAccess }) => {
//     const gridRef = useRef();
//     const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
//     const gridStyle = useMemo(() => ({ height: "100%", width: "100%", backgroundColor: "" }), []);
//     const [editingRowId, setEditingRowId] = useState(null); // Track which row is being edited


//     const handlePendingPartnerSelect = async (event, data) => {
//         console.log(data, ">>>>data");

//         if (!hasCheckerAccess) {
//             toast("User don't have access", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         } else {
//             if (selectedPendingPartnerName.length > 0) {
//                 let existingSelected = selectedPendingPartnerName[0];
//                 if (existingSelected.Id === data?.Id) {
//                     setGetRelatedPartnerName(false)
//                     setSelectedPendingPartnerName([])

//                     setPartnerNameValueForEditPartner("")
//                     setParentFieldValueForEditPartner(null)
//                 } else {
//                     setSelectedPendingPartnerName([data])
//                     setGetRelatedPartnerName(true)

//                     setPartnerNameValueForEditPartner(data?.sEntryPoint)
//                     if(data.sParentFieldValue === "Alliances_1"){
//                         setParentFieldValueForEditPartner({
//                             value: "Alliances_1",
//                             label: "Alliances_1",
//                         })
//                     }else if(data.sParentFieldValue === "Alliances_Inspire"){
//                         setParentFieldValueForEditPartner({
//                             value: "Alliances_Inspire",
//                             label: "Alliances_Inspire",
//                         })
//                     }
//                 }
//             } else {
//                 setSelectedPendingPartnerName([data])
//                 setGetRelatedPartnerName(true)

//                 setPartnerNameValueForEditPartner(data?.sEntryPoint)
//                 if(data.sParentFieldValue === "Alliances_1"){
//                     setParentFieldValueForEditPartner({
//                         value: "Alliances_1",
//                         label: "Alliances_1",
//                     })
//                 }else if(data.sParentFieldValue === "Alliances_Inspire"){
//                     setParentFieldValueForEditPartner({
//                         value: "Alliances_Inspire",
//                         label: "Alliances_Inspire",
//                     })
//                 }
//             }
//         }
//     }

//     const handleParentFieldSelect = (e, data) => {
//         console.log(tableData, ">>>>tableData");
//         console.log(e.target.value, ">>>e.target.value");
//         console.log(data, ">>>>partnerData");


//         // if(hasCheckerAccess){
//         //     setSelectedPartnerForUser([data]);
//         //     setParentFieldValue(e.target.value)
//         // }else{
//         //     toast("User don't have access", {
//         //         autoClose: 5000,
//         //         type: toast.TYPE.ERROR,
//         //     })
//         // }


//         if (hasCheckerAccess) {
//             setSelectedPartnerForUser([{ ...data, sParentFieldValue: e.target.value }]);
//             // setParentFieldValue(e.target.value)

//             let copyTableData = [...tableData];
//             let findIndexDataInCopyTableData = copyTableData.indexOf(data);
//             console.log(findIndexDataInCopyTableData, ">>>>findIndexDataInCopyTableData");
//             copyTableData[findIndexDataInCopyTableData] = { ...data, sParentFieldValue: e.target.value };
//             setPendingApprovalPartnerList(copyTableData);
//         } else {
//             toast("User don't have access", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         }
//     }

//     const columnDefs = [
//         {
//             headerName: "Sr No.",
//             valueGetter: (params) => params.node.rowIndex + 1,
//             width: 100,
//         },
//         {
//             headerName: "Pending Approval Partner Name",
//             // field: "sEntryPoint",
//             flex: 1,
//             cellRenderer: (params) => {
//                 let clickTimeout = null;
//                 const isEditing = editingRowId === params.data.Id; // Check if the current row is being edited

//                 return (
//                     // <p 
//                     //     onClick={(event) => {
//                     //         handlePendingPartnerSelect(event, params?.data);
//                     //     }} 
//                     //     style={{ 
//                     //         cursor: isRelatedPartnerLoading ? "not-allowed" : "pointer",
//                     //         opacity: isRelatedPartnerLoading ? 0.5 : 1 // Optional: visually indicate disabled state
//                     //     }}
//                     // >
//                     //     {params?.data?.sEntryPoint}
//                     // </p>

//                     <p
//                         onClick={(event) => {
//                             if (clickTimeout) {
//                                 clearTimeout(clickTimeout); // Prevent single-click action if double-click detected
//                                 clickTimeout = null;
//                             } else {
//                                 clickTimeout = setTimeout(() => {
//                                     handlePendingPartnerSelect(event, params?.data);
//                                     clickTimeout = null;
//                                 }, 200);
//                             }
//                         }}
//                         onDoubleClick={(event) => {
//                             clearTimeout(clickTimeout);
//                             clickTimeout = null;
//                             setEditingRowId(params.data.Id); // Set row as editable
//                             // setSelectedPartnerForCheckerEdit(params?.data);
//                             setSelectedRowEdit(params.data);
//                         }}
//                         style={{
//                             cursor: isRelatedPartnerLoading ? "not-allowed" : "pointer",
//                             opacity: isRelatedPartnerLoading ? 0.5 : 1,
//                         }}
//                     >
//                         {isEditing ? (
//                             <input
//                                 type="text"
//                                 value={params?.data?.sEntryPoint}
//                                 name="sEntryPoint"
//                                 onChange={(e) => handleEntryPointEditByChecker(e, params?.data)}
//                                 onBlur={() => setEditingRowId(null)} // Exit edit mode when input loses focus
//                                 autoFocus
//                                 style={{height: "35px" , marginTop:"5px"}}
//                             />
//                         ) : (
//                             params?.data?.sEntryPoint
//                         )}
//                     </p>

//                 )
//             }
//         },
//         {
//             headerName: "Parent Field",
//             // field: "valdiation status",
//             width: 180,
//             cellRenderer: (params) => {
//                 return (
//                     <div>
//                         <select style={{ height: "33px", width: "100%", borderRadius: "3px", backgroundColor: "#fff" }}
//                             // value={selectedPartnerForUser[0]?.Id === params.data.Id ? parentFieldValue  : ""}
//                             value={params.data.sParentFieldValue}
//                             // onChange={(e)=>setParentFieldValue(e.target.value, params)}
//                             onChange={(e) => handleParentFieldSelect(e, params.data)}
//                             name="sParentFieldValue"
//                         >
//                             {
//                                 parentFieldOptions.map((opt) => {
//                                     return <option value={opt.value}>{opt.label}</option>
//                                 })
//                             }
//                         </select>
//                     </div>

//                 )
//             }
//         },
//         {
//             headerName: "Status",
//             // field: "valdiation status",
//             width: 270,
//             cellRenderer: (params) => {
//                 return (
//                     <div className="d-flex" style={{ justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "5px" }}>
//                         <button className='my-services-model-submit-btn' onClick={() => approvePartnerName(params.data)} >Approve</button>
//                         <button className='my-services-model-submit-btn' onClick={() => deletePartnerName(params.data)}>Disapprove</button>
//                     </div>

//                 )
//             }
//         },
//     ];

//     console.log(tableData, ">>>tableData");
//     console.log(selectedPartnerForUser, ">>>selectedPartnerForUser");

//     return (
//         <div className={`${loading && "set-opacity"}`}>
//             <div style={{ height: `${selectedPendingPartnerName.length > 0 ? "15vh" : "75vh"}`, backgroundColor: "" }}>
//                 <div style={{ height: "100%", boxSizing: "border-box" }}>
//                     <div style={gridStyle} className="ag-theme-material">
//                         {loading && <Spinner className="center" />}
//                         <AgGridReact
//                             ref={gridRef}
//                             rowData={selectedPendingPartnerName.length > 0 ? selectedPendingPartnerName : tableData}
//                             columnDefs={columnDefs}
//                             pagination={selectedPendingPartnerName.length > 0 ? false : true}
//                             paginationPageSize={20}
//                         />
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default PendingPartnerMasterGrid;




///////////////////////////////////////////////////////////////////////
////// Modifying the code, edit partner name on select of one row
///////////////////////////////////////////////////////////////////////
// NEW ALL NEW WITH STORING CHECKED IN A VARIABLE- 
import React, { useMemo, useRef, useCallback, useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import api from "../../utils/api";
import Spinner from "../../common/Spinner/Spinner";
import Select from "react-select";
import { Button } from "../../common/Button/Button";
import { toast } from 'react-toastify'

const PendingPartnerMasterGrid = ({ tableData, setPendingApprovalPartnerList, selectedPendingPartnerName, setSelectedPendingPartnerName, loading, isRelatedPartnerLoading, parentFieldOptions, parentFieldValue, setParentFieldValue, selectedPartnerForUser, setSelectedPartnerForUser, approvePartnerName, deletePartnerName, getRelatedPartnerName = { getRelatedPartnerName }, setGetRelatedPartnerName, setPartnerNameValueForEditPartner, setParentFieldValueForEditPartner, setSelectedRowEdit, handleEntryPointEditByChecker, hasCheckerAccess }) => {
    const gridRef = useRef();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%", backgroundColor: "" }), []);
    const [editingRowId, setEditingRowId] = useState(null); // Track which row is being edited


    const handlePendingPartnerSelect = async (event, data) => {
        console.log(data, ">>>>data");

        if (!hasCheckerAccess) {
            toast("User don't have access", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else {
            if (selectedPendingPartnerName.length > 0) {
                let existingSelected = selectedPendingPartnerName[0];
                if (existingSelected.Id === data?.Id) {
                    setGetRelatedPartnerName(false)
                    setSelectedPendingPartnerName([])

                    setPartnerNameValueForEditPartner("")
                    setParentFieldValueForEditPartner(null)
                } else {
                    setSelectedPendingPartnerName([data])
                    setGetRelatedPartnerName(true)

                    setPartnerNameValueForEditPartner(data?.sEntryPoint)
                    if(data.sParentFieldValue === "Alliances_1"){
                        setParentFieldValueForEditPartner({
                            value: "Alliances_1",
                            label: "Alliances_1",
                        })
                    }else if(data.sParentFieldValue === "Alliances_Inspire"){
                        setParentFieldValueForEditPartner({
                            value: "Alliances_Inspire",
                            label: "Alliances_Inspire",
                        })
                    }else if(data.sParentFieldValue === "EEA_2026"){
                        setParentFieldValueForEditPartner({
                            value: "EEA_2026",
                            label: "EEA_2026",
                        })
                }
                }
            } else {
                setSelectedPendingPartnerName([data])
                setGetRelatedPartnerName(true)

                setPartnerNameValueForEditPartner(data?.sEntryPoint)
                if(data.sParentFieldValue === "Alliances_1"){
                    setParentFieldValueForEditPartner({
                        value: "Alliances_1",
                        label: "Alliances_1",
                    })
                }else if(data.sParentFieldValue === "Alliances_Inspire"){
                    setParentFieldValueForEditPartner({
                        value: "Alliances_Inspire",
                        label: "Alliances_Inspire",
                    })
                }else if(data.sParentFieldValue === "EEA_2026"){
                    setParentFieldValueForEditPartner({
                        value: "EEA_2026",
                        label: "EEA_2026",
                    })
                }
            }
        }
    }

    const handleParentFieldSelect = (e, data) => {
        console.log(tableData, ">>>>tableData");
        console.log(e.target.value, ">>>e.target.value");
        console.log(data, ">>>>partnerData");


        // if(hasCheckerAccess){
        //     setSelectedPartnerForUser([data]);
        //     setParentFieldValue(e.target.value)
        // }else{
        //     toast("User don't have access", {
        //         autoClose: 5000,
        //         type: toast.TYPE.ERROR,
        //     })
        // }


        if (hasCheckerAccess) {
            // setSelectedPartnerForUser([{ ...data, sParentFieldValue: e.target.value }]);
            // setParentFieldValue(e.target.value)

            let copyTableData = [...tableData];
            let findIndexDataInCopyTableData = copyTableData.indexOf(data);
            console.log(findIndexDataInCopyTableData, ">>>>findIndexDataInCopyTableData");
            copyTableData[findIndexDataInCopyTableData] = { ...data, sParentFieldValue: e.target.value };
            setPendingApprovalPartnerList(copyTableData);
        } else {
            toast("User don't have access", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        }
    }

    const columnDefs = [
        {
            headerName: "Sr No.",
            valueGetter: (params) => params.node.rowIndex + 1,
            width: 100,
        },
        {
            headerName: "Pending Approval Partner Name",
            // field: "sEntryPoint",
            flex: 1,
            cellRenderer: (params) => {
                let clickTimeout = null;
                const isEditing = editingRowId === params.data.Id; // Check if the current row is being edited

                return (
                    // <p 
                    //     onClick={(event) => {
                    //         handlePendingPartnerSelect(event, params?.data);
                    //     }} 
                    //     style={{ 
                    //         cursor: isRelatedPartnerLoading ? "not-allowed" : "pointer",
                    //         opacity: isRelatedPartnerLoading ? 0.5 : 1 // Optional: visually indicate disabled state
                    //     }}
                    // >
                    //     {params?.data?.sEntryPoint}
                    // </p>

                    <p
                        onClick={(event) => {
                            if (clickTimeout) {
                                clearTimeout(clickTimeout); // Prevent single-click action if double-click detected
                                clickTimeout = null;
                            } else {
                                clickTimeout = setTimeout(() => {
                                    handlePendingPartnerSelect(event, params?.data);
                                    clickTimeout = null;
                                }, 200);
                            }
                        }}
                        onDoubleClick={(event) => {
                            if (selectedPendingPartnerName.length > 0) { // Allow edit only if a row is selected
                                clearTimeout(clickTimeout);
                                clickTimeout = null;
                                setEditingRowId(params.data.Id); // Set row as editable
                                setSelectedRowEdit(params.data);
                            }
                        }}
                        style={{
                            cursor: isRelatedPartnerLoading ? "not-allowed" : "pointer",
                            opacity: isRelatedPartnerLoading ? 0.5 : 1,
                        }}
                    >
                        {isEditing ? (
                            <input
                                type="text"
                                value={params?.data?.sEntryPoint}
                                name="sEntryPoint"
                                onChange={(e) => handleEntryPointEditByChecker(e, params?.data)}
                                onBlur={() => setEditingRowId(null)} // Exit edit mode when input loses focus
                                autoFocus
                                style={{height: "35px" , marginTop:"5px"}}
                            />
                        ) : (
                            params?.data?.sEntryPoint
                        )}
                    </p>

                )
            }
        },
        {
            headerName: "Parent Field",
            // field: "valdiation status",
            width: 180,
            cellRenderer: (params) => {
                return (
                    <div>
                        {
                            hasCheckerAccess ? (
                                <select style={{ height: "33px", width: "100%", borderRadius: "3px", backgroundColor: "#fff" }}
                            // value={selectedPartnerForUser[0]?.Id === params.data.Id ? parentFieldValue  : ""}
                            value={params.data.sParentFieldValue}
                            // onChange={(e)=>setParentFieldValue(e.target.value, params)}
                            onChange={(e) => selectedPendingPartnerName.length>0 ? handleEntryPointEditByChecker(e, params?.data) : handleParentFieldSelect(e, params.data)}
                            name="sParentFieldValue"
                        >
                            {
                                parentFieldOptions.map((opt) => {
                                    return <option value={opt.value}>{opt.label}</option>
                                })
                            }
                        </select>
                            ) : (
                                <p>{ params?.data?.sParentFieldValue}</p>
                            )
                        }
                        
                    </div>

                )
            }
        },
        {
            headerName: "Status",
            // field: "valdiation status",
            width: 270,
            cellRenderer: (params) => {
                return (
                    
                    hasCheckerAccess ? (
                        <div className="d-flex" style={{ justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "5px" }}>
                        <button className='my-services-model-submit-btn' onClick={() => approvePartnerName(params.data)} >Approve</button>
                        <button className='my-services-model-submit-btn' onClick={() => deletePartnerName(params.data)}>Disapprove</button>
                    </div>

                    ) : (
                        <p>Pending for approval</p>
                    )

                )
            }
        },
    ];

    console.log(tableData, ">>>tableData");
    console.log(selectedPartnerForUser, ">>>selectedPartnerForUser");

    return (
        <div className={`${loading && "set-opacity"}`}>
            <div style={{ height: `${selectedPendingPartnerName.length > 0 ? "15vh" : "75vh"}`, backgroundColor: "" }}>
                <div style={{ height: "100%", boxSizing: "border-box" }}>
                    <div style={gridStyle} className="ag-theme-material">
                        {loading && <Spinner className="center" />}
                        <AgGridReact
                            ref={gridRef}
                            rowData={selectedPendingPartnerName.length > 0 ? selectedPendingPartnerName : tableData}
                            columnDefs={columnDefs}
                            pagination={selectedPendingPartnerName.length > 0 ? false : true}
                            paginationPageSize={20}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PendingPartnerMasterGrid;